import { ILegalClient } from '../../Interfaces/ILegalClient';

type BooleanLike = boolean | number | null | undefined;

type MeetingLegalClientInput = Omit<
  ILegalClient,
  | 'loginPossible'
  | 'passwordResetRequired'
  | 'isReceivingEmailEnabled'
  | 'syncWithArnoTop'
  | 'enableInvoiceReminding'
  | 'enableCertificateReminding'
> & {
  loginPossible: BooleanLike;
  passwordResetRequired: BooleanLike;
  isReceivingEmailEnabled: BooleanLike;
  syncWithArnoTop: BooleanLike;
  enableInvoiceReminding?: BooleanLike;
  enableCertificateReminding?: BooleanLike;
};

const toBoolean = (value: BooleanLike) => Number(value) !== 0;

export const normalizeMeetingLegalClient = (
  legalClient: MeetingLegalClientInput
): ILegalClient => ({
  ...legalClient,
  loginPossible: toBoolean(legalClient.loginPossible),
  passwordResetRequired: toBoolean(legalClient.passwordResetRequired),
  isReceivingEmailEnabled: toBoolean(legalClient.isReceivingEmailEnabled),
  syncWithArnoTop: toBoolean(legalClient.syncWithArnoTop),
  enableInvoiceReminding:
    legalClient.enableInvoiceReminding !== undefined
      ? toBoolean(legalClient.enableInvoiceReminding)
      : undefined,
  enableCertificateReminding:
    legalClient.enableCertificateReminding !== undefined
      ? toBoolean(legalClient.enableCertificateReminding)
      : undefined,
});

export const normalizeMeetingLegalClients = (
  legalClients: MeetingLegalClientInput[]
): ILegalClient[] => legalClients.map(normalizeMeetingLegalClient);
